import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { FooterService } from '../footer.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { log } from 'util';

@Component({
  selector: 'app-print-preview',
  templateUrl: './print-preview.component.html',
  styleUrls: ['./print-preview.component.css']
})
export class PrintPreviewComponent implements OnInit, OnDestroy {
  customer_details: any;
  chekoutArray: any;
  model: any;
  discount: any = [];
  tot_amt: number;
  Inv_tot: number = 0;
  disAmt: any;
  dataresult: any = [];
  typeOneCategory: {}[];
  multiple_offer: any = [];
  currentUser: any;
  coupons: any;
  applied: number = 0;
  addMinuss2: any;
  addMinuss3: any;
  addMinuss4: any;
  addMinuss5: any;
  offer_coupon: number = 0;
  invoiceTotal: number = 0;
  feedback: boolean = false;
  mOff: boolean = true;
  hideAdd: boolean = false;
  percentof30: number;
  service_offered_id: any;
  currDate: string;
  product_multiple_offer: any = [];
  productsTobuy: any = {};
  bill_no: number = 0;
  billed_on: any;
  full_bill: any = [];
  readcash: number = 0;
  readwallet: number = 0;
  readg_pay: number = 0;
  readcard: number = 0;
  readcheque: number = 0;
  readdue: number = 0;
  readonline_banking: number = 0;
  readsalary: number = 0;
  readtips: number = 0;
  add_charge: any;
  add_charge_value: Number = 0;
  add_charge_value2: Number = 0;
  add_charge_value3: Number = 0;
  add_charge_value4: Number = 0;
  add_charge_value5: Number = 0;

  add_charge_name: string = '';
  add_charge_name2: string = '';
  add_charge_name3: string = '';
  add_charge_name4: string = '';
  add_charge_name5: string = '';
  todayDate: string = '';
  from: any;
  module_access: any;
  modChange: boolean = false;
  billDateChange: boolean = false;
  gstEnabled: boolean = false;
  cgst: number = 0;
  sgst: number = 0;

  constructor(
    private router: Router,
    private activerouter: ActivatedRoute,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService,
    private footerService: FooterService

  ) {
    const today = new Date();
    this.todayDate = today.toISOString().split('T')[0]; // yyyy-MM-dd
  }

  ngOnInit() {
    this.footerService.hideFooter();
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.gstEnabled = this.currentUser['gstEnabled'];
    if (this.gstEnabled == true) {
      // this.cgst = 0;
      // this.sgst = 0;
      this.cgst = this.currentUser['cgst'];
      this.sgst = this.currentUser['sgst'];
    } else {
      this.cgst = 0;
      this.sgst = 0;
    }
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    this.billDateChange = this.checkModuleAcces('33');
    this.modChange = this.checkModuleAcces('34');
    this.activerouter.queryParams.subscribe(params => {
      this.model = JSON.parse(params['model']);
      this.tot_amt = JSON.parse(params['tot_amt']);
      this.invoiceTotal = JSON.parse(params['invoiceTotal']);
      this.multiple_offer = JSON.parse(params['multiple_offer']);
      this.chekoutArray = JSON.parse(params['chekoutArray']);
      this.discount = JSON.parse(params['discount']);
      this.product_multiple_offer = JSON.parse(params['product_multiple_offer']);
      this.productsTobuy = JSON.parse(params['productsTobuy']);
      this.bill_no = JSON.parse(params['bill_no']);
      this.add_charge = JSON.parse(params['add_charge']);
      this.billed_on = JSON.parse(params['billed_on']);
      this.from = JSON.parse(params['from']);
      this.billed_on = this.billed_on.split(' ')[0];
      this.model['cash'] = 0;
      this.model['g_pay'] = 0;
      this.model['card'] = 0;
      this.model['tips'] = 0;
      this.model['cheque'] = 0;
      this.model['due'] = 0;
      this.model['online_banking'] = 0;
      this.model['salary'] = 0;
      if (this.add_charge.length > 0) {
        this.add_charge_value = this.add_charge[0].add_charge;
        this.add_charge_value2 = this.add_charge[0].add_charge2;
        this.add_charge_value3 = this.add_charge[0].add_charge3;
        this.add_charge_value4 = this.add_charge[0].add_charge4;
        this.add_charge_value5 = this.add_charge[0].add_charge5;

        this.add_charge_name = this.add_charge[0].charge_name;
        this.add_charge_name2 = this.add_charge[0].charge_name2;
        this.add_charge_name3 = this.add_charge[0].charge_name3;
        this.add_charge_name4 = this.add_charge[0].charge_name4;
        this.add_charge_name5 = this.add_charge[0].charge_name5;
      } else {
        this.add_charge_value = 0;
        this.add_charge_value2 = 0;
        this.add_charge_value3 = 0;
        this.add_charge_value4 = 0;
        this.add_charge_value5 = 0;

        this.add_charge_name = '';
        this.add_charge_name2 = '';
        this.add_charge_name3 = '';
        this.add_charge_name4 = '';
        this.add_charge_name5 = '';
      }

      if (params['full_bill'] && JSON.parse(params['full_bill'])) {

        this.full_bill = JSON.parse(params['full_bill']);
      } else {
        this.loginservice.full_bill(this.bill_no, this.currentUser).subscribe(
          data => {
            this.full_bill = data['comp_details'];
            this.readcash = data['cash'];
            this.readwallet = data['wallet'];
            this.readg_pay = data['g_pay'];
            this.readcard = data['card'];
            this.readtips = data['tips'];
            this.readcheque = data['cheque'];
            this.readdue = data['due'];
            this.readonline_banking = data['online_banking'];
            this.readsalary = data['salary'];
            this.model.cash = data['cash'];
            this.model.g_pay = data['g_pay'];
            this.model.card = data['card'];
            this.model.cheque = data['cheque'];
            this.model.due = data['due'];
            this.model.online_banking = data['online_banking'];
            this.model.salary = data['salary'];
            this.model.tips = data['tips'];
          }, error => { alert('Network Error fullbill API'); });
      }
    }, error => { alert('Network Error params API'); });

    // Get current date
    var currentDate = new Date();
    // Extract day, month, and year
    var day = currentDate.getDate().toString();
    var month = (currentDate.getMonth() + 1).toString(); // January is 0, so we add 1
    var year = currentDate.getFullYear().toString();
    // Ensure day and month are in two-digit format
    if (day.length < 2) {
      day = '0' + day;
    }
    if (month.length < 2) {
      month = '0' + month;
    }
    // Format the date as "dd-mm-yyyy"
    this.currDate = day + '-' + month + '-' + year;
  }

  dateChange() {
    if (this.billed_on) {
      const selectedDate = new Date(this.billed_on);
      const today = new Date(this.todayDate);
      // Reset if selected date is in the future
      if (selectedDate > today) {
        alert('Future dates are not allowed!');
        this.billed_on = this.todayDate; // Reset to today's date or clear
        // Optional: Notify backend or log this action (if required)
        return;
      }
      // Proceed with valid date
      this.loginservice.dateChange(this.billed_on, this.bill_no, this.currentUser).subscribe(
        (data) => {
        },
        (error) => {
          alert('Network Error dateChange API');
          console.error('Error updating date:', error);
        }
      );
    }
  }


  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      return true; // module exists
    } else {
      // If not found, reset and return false
      return false;
    }
  }


  paymentMode() {
    let totPay = parseInt(this.model['cash']) + parseInt(this.model['g_pay']) + parseInt(this.model['card']) + parseInt(this.model['cheque']) + parseInt(this.model['due']) + parseInt(this.model['online_banking']) + parseInt(this.model['salary'])
    if (this.invoiceTotal + Number(this.model['advwallet']) + Number(this.add_charge_value) + Number(this.add_charge_value2) + Number(this.add_charge_value3) + Number(this.add_charge_value4) + Number(this.add_charge_value5) == totPay) {
      this.loginservice.savepaymentMode(this.model, this.bill_no, this.currentUser)
        .subscribe(
          data => {
            this._flashMessagesService.show('Payment Mode Saved!', { cssClass: 'alert-success' });
          }, error => { alert('Network Error savepaymentMode API'); });
    } else {
      alert('mis match')
    }
  }

  paymentModeWallet() {
    this.paymentMode();
    this.loginservice.savepaymentModeWallet(this.model, this.bill_no, this.currentUser)
      .subscribe(
        data => {
          this._flashMessagesService.show('Payment Mode Saved!', { cssClass: 'alert-success' });
        }, error => { alert('Network Error savepaymentModeWallet API'); });
  }

  getDisc(sid, bill_no) {
    for (let i = 0; i < this.full_bill.length; i++) {
      let element = this.full_bill[i];
      if (element.bill_no === bill_no && element.service_desc_id === sid) {
        let reAmnt = ((element.discounted_amount / element.amount1) * 100);
        if (reAmnt > 0) {
          return (Math.floor(reAmnt * 10) / 10).toFixed(1) + '%';
        } else {
          return null;
        }
      }
    }
    return null;
  }

  getKeyValues(obj: any, name): { key: string, value: any[] }[] {
    if (obj) {
      return Object.keys(obj).map(key => ({ key, value: obj[key] }));
    } else {
      return this[name] = [];
    }
  }

  // public mprint() {
  //   window.print();
  // }

  convertToWords(number: number): string {
    if (number === 0) return 'Rupees Zero Only';
    if (number < 0 || !isFinite(number)) return 'Invalid Amount';

    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const scales = ['', 'Thousand', 'Million', 'Billion'];

    const convertHundreds = (n: number): string => {
      let result = '';
      if (n >= 100) {
        result += units[Math.floor(n / 100)] + ' Hundred ';
        n %= 100;
      }
      if (n >= 20) {
        result += tens[Math.floor(n / 10)];
        if (n % 10 > 0) result += ' ' + units[n % 10];
      } else if (n > 0) {
        result += units[n];
      }
      return result.trim();
    };

    let integerPart = Math.floor(number);
    let result = '';
    let scaleIndex = 0;

    while (integerPart > 0 && scaleIndex < scales.length) {
      let chunk = integerPart % 1000;
      if (chunk > 0) {
        let chunkWords = convertHundreds(chunk);
        if (scaleIndex > 0) chunkWords += ' ' + scales[scaleIndex];
        result = chunkWords + (result ? ' ' + result : '');
      }
      integerPart = Math.floor(integerPart / 1000);
      scaleIndex++;
    }

    return 'Rupees ' + (result || 'Zero') + ' Only';
  }

  public mprint() {
    window.print();
  }


  ngOnDestroy() {
    this.footerService.showFooter();
  }

  private navigateToPrintRoute() {
    this.router.navigate(['print'], {
      queryParams: {
        model: JSON.stringify(this.model),
        tot_amt: JSON.stringify(this.tot_amt),
        invoiceTotal: JSON.stringify(this.invoiceTotal),
        multiple_offer: JSON.stringify(this.multiple_offer),
        chekoutArray: JSON.stringify(this.chekoutArray),
        discount: JSON.stringify(this.discount),
      }
    });
  }

  toNum(add_charge_value) {
    if (add_charge_value == null || add_charge_value == undefined || add_charge_value == '') {
      return 0;
    }
    return Number(add_charge_value);
  }

  roundGst(value) {
    return Math.round(value);
  }

  getBillLogoPath(): string {
    if (this.currentUser && this.currentUser.billLogo) {
      // If salon has custom bill logo, use upload URL
      return `${environment.uploadUrl}uploads/salon_bill_logos/${this.currentUser.billLogo}`;
    }
    // Default logo
    return '';
  }

  convertTo12Hour(time: string): string {
    if (!time || time === '00:00:00') return '';

    const [hours, minutes, seconds] = time.split(':').map(Number);

    let period = hours >= 12 ? 'PM' : 'AM';
    let hour12 = hours % 12 || 12;

    return `${hour12}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  getTotalHours(inTime: string, outTime: string): string {
    if (!inTime || !outTime || inTime === '00:00:00' || outTime === '00:00:00') {
      return '';
    }

    const parseTime = (time: string) => {
      const parts = time.split(':').map(Number);
      return {
        h: parts[0] || 0,
        m: parts[1] || 0,
        s: parts[2] || 0   // ✅ FIX (default 0)
      };
    };

    const inT = parseTime(inTime);
    const outT = parseTime(outTime);

    const inDate = new Date(0, 0, 0, inT.h, inT.m, inT.s);
    const outDate = new Date(0, 0, 0, outT.h, outT.m, outT.s);

    let diff = (outDate.getTime() - inDate.getTime()) / 1000;

    // ✅ overnight fix
    if (diff < 0) {
      diff += 24 * 3600;
    }

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);

    return `${hours}h ${minutes}m`;
  }

}




// WEBPACK FOOTER //
// ./src/app/print-preview/print-preview.component.ts